import { Component, Input, Output, OnInit, OnDestroy, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { AbstractControl, FormArray, FormGroup, ControlContainer, FormControl, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { FormArray, FormGroup, FormControl, FormBuilder, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { BehaviorSubject, Observable, pipe, Subscription } from 'rxjs';

import { AttributesService } from './attributes.service';
import { TemplateAttribute, ProductAttribute, Product, ProductTpl,  Packaging, ProductPackagingVal } from '@app/shared/_models/product';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import * as constants from "@app/shared/constants";
import { SmartSelectComponent } from '@app/shared/smart-select/smart-select.component'

@Component({
    selector: 'app-attributes',
    templateUrl: './attributes.component.html',
    styleUrls: ['./attributes.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, MatButtonModule, MatIconModule, SmartSelectComponent]
})
export class AttributesComponent implements OnInit, OnDestroy {
	constructor(private route: ActivatedRoute, private location: Location, private attributesService: AttributesService, public controlContainer: ControlContainer, private router: Router, private fb: FormBuilder) { }
	
	@Input() template_id!:number;	// template_id comes from parent	
	@Input() loadProductTplEventsSubject$!: Observable<FormGroup>;				// Parent productTpl was loaded
	// @Input() loadEventsSubject$!: Observable<boolean>;

  @Output("updateProductAttributes") updateAttributesEvent : EventEmitter<any> = new EventEmitter<any>(); // To send update to parent
	private eventsSubscription!: Subscription;
	
	// public formGroup: FormGroup = this.fb.group({
	// 	tplAttributes: this.fb.array([])
	// });
  public formGroup!: FormGroup;
  // public productTpl! : ProductTpl;
	public attributes: any[] =[];
	public newattribute: FormControl=new FormControl('');
	private lastseq=0;						// Attribute sequence
	public tab: number=0;					// Active tab index

	ngOnInit(): void {
		// console.log("AttributesComponent ngOnInit template_id: " + this.template_id);
		
  	this.route.queryParams.subscribe(params => {	// 	Is there a tab number in URL? 
			if (params && params['tab'] != null) {
				this.tab=Number(params['tab']);
			} 
		});						
		
		this.eventsSubscription = this.loadProductTplEventsSubject$.subscribe((formGroup:FormGroup) => { 	// Triggered on Order loading. Flag is unused
      this.formGroup = formGroup;
      // console.log('formGroup',formGroup.value);
      // console.log('Variable : formGroup.value.id', formGroup.value.id);
      if (formGroup && formGroup.value && formGroup.value.id) {	
        // this.productTpl = formGroup.value;
				this.load();
			} 
		});	
	}
	
	private load() {	// Load template attributes & filter listbox (this.attributes) to remove unwanted values
		// console.log("AttributesComponent in load");
    // console.log('Variable : this.formGroup.value.id', this.formGroup.value.id);

    				this.attributesService.getAttributes()	// Get all attributes (for listbox)
					.subscribe((ats: ProductAttribute[]) => {
						this.attributes = ats;
				});
	}
	
	public deleteLine(attribute_id: number){
		// console.log("Delete attribute_id: " + attribute_id);
    // const formArray = this.formGroup.get('lnk_product_attributes') as FormArray;
    //   // Trouver l'index de l'élément avec l'ID correspondant
    // const index = formArray.controls.findIndex(
    //   (control) => control.get('id')?.value === attribute_id
    // );
  
    // // Supprimer l'élément si trouvé
    // if (index !== -1) {
    //   formArray.removeAt(index);
    // }
    this.attributesService.deletetTplattribute(this.formGroup.value.id, attribute_id)
				.subscribe((response: any) => {
					console.log("Server response: " + JSON.stringify(response));
					this.router.navigateByUrl('sales/product-tpl/' + this.formGroup.value.id);
					// this.load();
				});


	}
	
	public moveLine(attribute_id: number, seq: number, action: number){
		console.log("Move attribute_id: " + attribute_id + " - " + action + " - seq = " + seq);
		this.attributesService.postTplattributeaction({"template_id":this.formGroup.value.id, "attribute_id":attribute_id, "seq":seq, "action":action})
			.subscribe((response: any) => {
				console.log("Server response: " + JSON.stringify(response));
				this.router.navigateByUrl('sales/product-tpl/' + this.formGroup.value.id);
				// this.load();
			});
	}	
	
	onAddattribute() {
		console.log("onAddattribute");
    console.log('Variable : this.newattribute.value', this.newattribute.value);
		if (!isNaN(this.newattribute.value)) {
		let templateAttribute: TemplateAttribute = {
			template: +this.formGroup.value.id,
			attribute: +this.newattribute.value,
			seq: ++this.lastseq,
			lnk_product_attribute:undefined,
		}
		this.attributesService.postTplattributeEvent( constants.EVENTTYP_TPL_ATTRIBUTE_I, this.formGroup.value.id  , constants.ObjectType.TEMPLATE,   templateAttribute).subscribe((response: any) => {
			console.log("Server response: " + JSON.stringify(response));
				this.router.navigateByUrl('/sales/product-tpl/' + this.formGroup.value.id);
			// this.router.navigate(['/sales/product-tpl/' + response.data.template_id]);	// Reload Template
		});				
    
    
	} else {	// Should NOT happen, packaging is comming from a listbox
		
	}
		this.newattribute.setValue('');
	}
	
	ngOnDestroy() {
		this.eventsSubscription.unsubscribe();
	}	

	get tplAttributes(): FormGroup[] {
		return (this.formGroup.get('lnk_product_attributes') as FormArray).controls as FormGroup[];
	}
	
// La fonction fléchée garde le 'this' attaché au composant parent
isAttributeInTemplate = (attribute: any): boolean => {
  return this.tplAttributes.some(tplAttribute => tplAttribute.get('id')?.value === attribute.id);
}
	
}
